import { API_BASE_URL } from './apiClient'

const REPORT_URL = `${API_BASE_URL}/v1/frontend-errors/`
const MAX_MESSAGE_LENGTH = 2000
const MAX_STACK_LENGTH = 8000

// Fire-and-forget: must never throw, recurse into window.onerror/Vue's error
// handler, or trigger apiClient's 401 refresh-retry logic — this is why it
// uses a bare fetch() instead of apiClient.js's request() helper.
export function reportError({ message, stack, context, url } = {}) {
  const body = JSON.stringify({
    message: String(message ?? '').slice(0, MAX_MESSAGE_LENGTH),
    stack: String(stack ?? '').slice(0, MAX_STACK_LENGTH),
    context: context ?? '',
    url: url ?? window.location.href,
  })

  fetch(REPORT_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
  }).catch(() => {})
}
